import { render, staticRenderFns } from "./AddEquipmentDialog.vue?vue&type=template&id=58bc97cb"
import script from "./AddEquipmentDialog.vue?vue&type=script&lang=js"
export * from "./AddEquipmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports